export const useSplide = () => {
	/** Programatically triggers the next slide */
	const nextSlide = (splideRef: any) => {
		splideRef?.splide?.go(">")
	}
	/** Programatically triggers the previous slide */
	const prevSlide = (splideRef: any) => {
		splideRef?.splide?.go("<")
	}

	return {
		nextSlide,
		prevSlide,
	}
}
